// Archive calls made with the active persona's own Supabase session. Reading a file
// and asking the worker to run never change the permit: the archive worker is the only
// writer of archive results, and it cannot reopen work (WF-020).
import { requireActiveClient } from '@/lib/session'
import { ARCHIVE_BUCKET, SIGNED_URL_SECONDS } from './logic'

/** A five-minute download link for one archived file in the ptw-archive bucket. */
export async function createArchiveDownloadUrl(storagePath: string): Promise<string> {
  const client = requireActiveClient()
  const { data, error } = await client.storage.from(ARCHIVE_BUCKET).createSignedUrl(storagePath, SIGNED_URL_SECONDS)
  if (error) throw error
  return data.signedUrl
}

/** Asks the archive worker to process waiting jobs once. */
export async function runArchiveWorker(): Promise<void> {
  const client = requireActiveClient()
  const { error } = await client.functions.invoke('archive-worker', { body: {} })
  if (error) throw error
}

/** Plain message for a failed storage or function call (reads the function's JSON error when present). */
export async function describeFailure(e: unknown): Promise<string> {
  const context = (e as { context?: unknown } | null)?.context
  if (context && typeof (context as Response).json === 'function') {
    try {
      const body = (await (context as Response).clone().json()) as { error?: unknown; message?: unknown }
      const text = typeof body.error === 'string' ? body.error : typeof body.message === 'string' ? body.message : null
      if (text) return text
    } catch {
      /* not JSON: fall back to the error message */
    }
  }
  if (e instanceof Error && e.message) return e.message
  return typeof e === 'string' && e ? e : 'Unknown error'
}
